module.exports = __webpack_public_path__ + "cf6c266dd2fdb1ac23de09cbaebce137.fbx";